import { Root, Portal, Content, Trigger } from "@radix-ui/react-popover";
import { ReactNode, Dispatch, SetStateAction, useState } from "react";
import { ReactComponent as FilterSvg } from "../../../assets/filter.svg";
import { ReactComponent as DropDownSvg } from "../../../assets/dropdown.svg";
import styles from "./style.module.css";

interface FilterModalProps {
  children?: ReactNode;
  options?: { value: string; code: number }[];
  onSelect?: ({ value, code }: { value: string; code: number }) => void;
  selected?: number;
  table?: boolean;
  currentLabel?: string;
  open?: boolean;
  setOpen?: Dispatch<SetStateAction<boolean>>;
}

export const FilterModal = ({
  options,
  selected,
  onSelect = () => {},
  table,
  children,
  currentLabel = "Filter",
  open: filterOpen,
  setOpen: setFilterOpen,
}: FilterModalProps) => {
  const active = (code: number) => !!(selected === code);

  const [open, setOpen] = useState<boolean | undefined>();

  return (
    <div>
      <Root
        open={filterOpen ?? open}
        onOpenChange={(state) => {
          setOpen(state);
          setFilterOpen && setFilterOpen(state);
        }}
      >
        <Trigger className={`${styles.flexbtwn} gap-10`}>
          <FilterSvg />
          <h3>{currentLabel}</h3>
          <DropDownSvg />
        </Trigger>
        <Portal>
          <Content
            className={
              table
                ? `${styles.bigFilterContainer}`
                : `${styles.filterContainer} `
            }
          >
            {/* <h3>Filter;</h3> */}
            <div className="divider" />
            <>
              {table ? (
                <div className={styles.bigFilter}>{children}</div>
              ) : (
                <div className={styles.menu}>
                  {options?.map((option, index) => (
                    <div
                      key={option.value}
                      className={`${active(option.code) ? "text-green" : ""}`}
                      onClick={() => {
                        setOpen(false);
                        onSelect({ code: option.code, value: option.value });
                      }}
                    >
                      {`${option.value
                        .charAt(0)
                        .toUpperCase()}${option.value.slice(1)}`}
                      {index + 1 !== options.length && <hr />}
                    </div>
                  ))}
                </div>
              )}
            </>
          </Content>
        </Portal>
      </Root>
    </div>
  );
};
